
function unoAccordion() {
    const accordionItem = [...document.querySelectorAll(".js-accordion-item")];
    const accordionButtons = [...document.querySelectorAll(".js-accordion-btn")];

    accordionButtons.forEach((btn) => {

        btn.addEventListener("click", (e) => {
            e.preventDefault();

            // const currentlyActiveAccordionItem = document.querySelector('.js-accordion-btn.is-active');
            // console.log(currentlyActiveAccordionItem);

            // if (currentlyActiveAccordionItem && currentlyActiveAccordionItem !== btn) {
            //     currentlyActiveAccordionItem.classList.toggle('is-active');
            //     currentlyActiveAccordionItem.nextElementSibling.style.maxHeight = 0;
            // }

            btn.classList.toggle("is-active");

            const panel = btn.nextElementSibling;

            if (btn.classList.contains('is-active')) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            } else {
                panel.style.maxHeight = 0;
            }
        });
    });
}






// function unoAccordion() {
//     const accordionItem = [...document.querySelectorAll(".js-accordion-item")];
//     const accordionButtons = [...document.querySelectorAll(".js-accordion-btn")];

//     console.log(accordionButtons);
//     let isAccOpen = false;

//     accordionItem.forEach((group) => {

//         const btn = group.querySelector('.js-accordion-btn');

//         btn.addEventListener("click", (e) => {
//             e.preventDefault();

//             accordionItem.forEach((group) => {
//                 group.classList.remove('is-active');
//             });

            
//             // if (isAccOpen) {
//             //     btn.parentNode.classList.add('is-active');
//             // } else {
//             //     btn.parentNode.classList.remove('is-active');
//             // }

//             // const panel = btn.nextElementSibling;

//             // if (panel.style.maxHeight) {
//             //     panel.style.maxHeight = null;
//             // } else {
//             //     panel.style.maxHeight = panel.scrollHeight + "px";
//             // }
//         });
//     });
// }